// Copy of the drama / film upsell screens, one file per family and language,
// generated from the localization package ("* Upsell Text EN.docx" and
// "*_Upsells_Localizations_*.docx"). A content fix arrives as a new package,
// not as a hand edit.
//
// Each screen's copy is a view_data blob: the keys are the ones the screens
// already read from admin view_data (see data/upsells/registry.ts), plus the
// keys of the family-only visuals. Keys absent from a locale (images, emojis,
// the bundle discount) are inherited from English.
import type { IUpsellViewData } from "@features/shared/entities/student";
import type { CreativeFamily } from "@features/upsell/creative";
import dramaAr from "./drama/ar.json";
import dramaDe from "./drama/de.json";
import dramaEn from "./drama/en.json";
import dramaEs from "./drama/es.json";
import dramaFr from "./drama/fr.json";
import dramaJa from "./drama/ja.json";
import dramaPtBr from "./drama/pt_br.json";
import filmAr from "./film/ar.json";
import filmDe from "./film/de.json";
import filmEn from "./film/en.json";
import filmEs from "./film/es.json";
import filmFr from "./film/fr.json";
import filmJa from "./film/ja.json";
import filmPtBr from "./film/pt_br.json";

export type CreativeCopy = {
    skill: IUpsellViewData;
    aiTools: IUpsellViewData;
    incomeKit: IUpsellViewData;
    bundle: IUpsellViewData;
};

const COPY = {
    drama: { en: dramaEn, es: dramaEs, de: dramaDe, fr: dramaFr, ja: dramaJa, pt_br: dramaPtBr, ar: dramaAr },
    film: { en: filmEn, es: filmEs, de: filmDe, fr: filmFr, ja: filmJa, pt_br: filmPtBr, ar: filmAr }
} as unknown as Record<CreativeFamily, Record<string, CreativeCopy>>;

export const getCreativeCopy = (family: CreativeFamily, language: string): CreativeCopy => {
    const en = COPY[family].en;
    const local = COPY[family][language] ?? en;
    return {
        skill: { ...en.skill, ...local.skill },
        aiTools: { ...en.aiTools, ...local.aiTools },
        incomeKit: { ...en.incomeKit, ...local.incomeKit },
        bundle: { ...en.bundle, ...local.bundle }
    };
};
